import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { GeckoFields, GECKO_CONSTS } from 'ui';
import validator from 'validator';

class CCForm extends Component {
  static propTypes = {
    cc: PropTypes.arrayOf(PropTypes.string),
    bcc: PropTypes.arrayOf(PropTypes.string),
    onCCChange: PropTypes.func,
    onBCCChange: PropTypes.func,
  };

  validateOption(input) {
    const label = input.label;
    return validator.isEmail(label || '');
  }

  fields = [
    {
      label: 'CC:',
      key: 'cc',
      type: GECKO_CONSTS.FIELD_TYPE_SELECT_CREATE_MULTI,
      options: [],
      width: '100',
      placeholder: 'Enter an email address to CC',
      config: {
        noResultsText: 'Add a new email address',
        isValidNewOption: this.validateOption.bind(this),
        promptTextCreator: (label) => `CC "${label}" in on emails`,
      },
    },
    {
      label: 'BCC:',
      key: 'bcc',
      type: GECKO_CONSTS.FIELD_TYPE_SELECT_CREATE_MULTI,
      options: [],
      width: '100',
      placeholder: 'Enter an email address to BCC',
      config: {
        noResultsText: 'Add a new email address',
        isValidNewOption: this.validateOption.bind(this),
        promptTextCreator: (label) => `BCC "${label}" in on emails`,
      },
    },
  ];

  handleChange(key, value) {
    if (key === 'cc') {
      this.props.onCCChange(value);
    }
    if (key === 'bcc') {
      this.props.onBCCChange(value);
    }
  }

  shouldComponentUpdate(nextProps) {
    if (
      this.props.cc &&
      this.props.bcc &&
      JSON.stringify(nextProps.cc) === JSON.stringify(this.props.cc) &&
      JSON.stringify(nextProps.bcc) === JSON.stringify(this.props.bcc)
    ) {
      return false;
    }
    return true;
  }

  render() {
    return (
      <div className="CCForm">
        <div className="row">
          <GeckoFields
            fields={this.fields}
            values={{ cc: this.props.cc, bcc: this.props.bcc }}
            handler={this.handleChange.bind(this)}
          />
        </div>
      </div>
    );
  }
}

export default CCForm;
